"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PopoverContext: ()=>PopoverContext,
    PopoverProvider: ()=>PopoverProvider,
    usePopoverContext_unstable: ()=>usePopoverContext_unstable
});
const _reactContextSelector = require("@fluentui/react-context-selector");
const PopoverContext = /*#__PURE__*/ (0, _reactContextSelector.createContext)(undefined);
const popoverContextDefaultValue = {
    open: false,
    setOpen: ()=>null,
    toggleOpen: ()=>null,
    triggerRef: {
        current: null
    },
    contentRef: {
        current: null
    },
    arrowRef: {
        current: null
    },
    openOnContext: false,
    openOnHover: false,
    size: 'medium',
    trapFocus: false,
    inline: false
};
const PopoverProvider = PopoverContext.Provider;
const usePopoverContext_unstable = (selector)=>(0, _reactContextSelector.useContextSelector)(PopoverContext, (ctx = popoverContextDefaultValue)=>selector(ctx)); //# sourceMappingURL=popoverContext.js.map

//# sourceMappingURL=popoverContext.js.map